// extracted by mini-css-extract-plugin
export var logo = "_l3-2";
export var logoWrapper = "_l3-1";
export var strip = "_l3-0";